import React, { useEffect, useState } from "react";
import PostalCodeDetails from "./PostalCodeDetails";
import ErrorMessage from "./ErrorMessage";
import MapComponent from "./MapComponent";
import { motion } from "framer-motion";
import { ReactTyped } from "react-typed";

const text = "";

const LocatorF = () => {
  const [pincode, setPincode] = useState("");
  const [place, setPlace] = useState("");
  const [district, setDistrict] = useState("");
  const [state, setState] = useState("");
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [division, setDivision] = useState("");
  const [location, setLocation] = useState(null);
  const [searchByLocation, setSearchByLocation] = useState({
    state: "",
    district: "",
    place: "",
  });

  useEffect(() => {
    handleSearch();
  }, [pincode]);

  const handleSearch = async (e) => {
    if (e) e.preventDefault();
    if (pincode.length === 6) {
      await fetchDataByPincode(pincode);
    } else if (
      searchByLocation.state &&
      searchByLocation.district &&
      searchByLocation.place
    ) {
      await fetchPincodeByLocation(searchByLocation);
    } else {
      setError("Please provide valid inputs for search.");
    }
  };

  const fetchDataByPincode = async (pincode) => {
    try {
      setError("");
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${pincode}`
      );
      const data = await response.json();

      if (data[0].Status === "Success") {
        const postOfficeData = data[0].PostOffice[0];
        setPlace(postOfficeData.Name);
        setDistrict(postOfficeData.District);
        setState(postOfficeData.State);
        setAddress(`${postOfficeData.Name}, ${postOfficeData.District}`);
        setName(postOfficeData.Name);
        setDivision(postOfficeData.Division);

        const geoResponse = await fetch(
          `https://api.opencagedata.com/geocode/v1/json?q=${postOfficeData.Name},${postOfficeData.District},${postOfficeData.State}&key=059d06a9d88c40558d2aebf49179cd88`
        );
        const geoData = await geoResponse.json();
        if (geoData.results.length > 0) {
          const { lat, lng } = geoData.results[0].geometry;
          setLocation([lat, lng]);
        } else {
          setError("Geolocation not found");
        }
      } else {
        setError("Invalid pincode or data not found");
        clearLocationData();
      }
    } catch (err) {
      setError("Error fetching data");
      clearLocationData();
    }
  };

  const fetchPincodeByLocation = async ({ state, district, place }) => {
    try {
      setError("");
      const response = await fetch(
        `https://api.postalpincode.in/postoffice/${place}`
      );
      const data = await response.json();
      console.log("API Response:", data);

      if (data[0].Status === "Success") {
        const results = data[0].PostOffice.filter(
          (office) =>
            office.State.toLowerCase() === state.toLowerCase() &&
            office.District.toLowerCase() === district.toLowerCase()
        );
        if (results.length > 0) {
          setPincode(results[0].Pincode);
        } else {
          setError("No pincode found for the given location");
        }
      } else {
        setError("No data found for the given location");
      }
    } catch (err) {
      setError("Error fetching data");
    }
  };

  const clearLocationData = () => {
    setPlace("");
    setDistrict("");
    setState("");
    setAddress("");
    setName("");
    setDivision("");
    setLocation(null);
  };

  return (
    <div
      className="flex flex-col gap-6 p-4 sm:p-6 bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500"
      style={{
        backgroundImage: `url('https://www.guideoftheworld.com/wp-content/uploads/map/india_geographical_map.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
    >
      <motion.h2 className="text-2xl sm:text-4xl font-semibold mb-8 sm:mb-14 text-red-700 text-center mt-28">
        <ReactTyped
          strings={[
            "Pincode/Post Office Locator",
            "Postal Code Location Finder",
          ]}
          typeSpeed={100}
          loop
        />
      </motion.h2>

      <div className="rounded-xl border mx-auto px-4 sm:px-8 py-6 sm:py-12 flex flex-col justify-evenly lg:flex-row lg:justify-center lg:items-center bg-black bg-opacity-80 shadow-lg w-full max-w-6xl">
        <div className="flex flex-col gap-6 w-full lg:w-1/2">
          <h2 className="border border-yellow-300 bg-yellow-50 text-yellow-800 w-fit px-3 py-1 rounded-lg font-medium font-display">
            Search & Find Postal Codes of India
          </h2>

          <form className="flex flex-col gap-4 w-full" onSubmit={handleSearch}>
            <div className="flex flex-col">
              <label className="text-lg font-semibold text-white font-bold">
                Pincode
              </label>
              <motion.input
                whileFocus={{ scale: 1.07 }}
                className="border border-b-slate-700 rounded-md py-1 px-4 mt-1"
                type="text"
                value={pincode}
                onChange={(e) => setPincode(e.target.value)}
                placeholder="Enter pincode"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-lg font-semibold text-white font-bold">
                City
              </label>
              <motion.input
                whileFocus={{ scale: 1.07 }}
                className="border border-b-slate-700 rounded-md py-1 px-4 mt-1"
                type="text"
                value={searchByLocation.place || place}
                onChange={(e) =>
                  setSearchByLocation({
                    ...searchByLocation,
                    place: e.target.value,
                  })
                }
                placeholder="City"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-lg font-semibold text-white font-bold">
                District
              </label>
              <motion.input
                whileFocus={{ scale: 1.07 }}
                className="border border-b-slate-700 rounded-md py-1 px-4 mt-1"
                type="text"
                value={searchByLocation.district || district}
                onChange={(e) =>
                  setSearchByLocation({
                    ...searchByLocation,
                    district: e.target.value,
                  })
                }
                placeholder="District"
              />
            </div>

            <div className="flex flex-col">
              <label className="text-lg font-semibold text-white font-bold">
                State
              </label>
              <motion.input
                whileFocus={{ scale: 1.07 }}
                className="border border-b-slate-700 rounded-md py-1 px-4 mt-1"
                type="text"
                value={searchByLocation.state || state}
                onChange={(e) =>
                  setSearchByLocation({
                    ...searchByLocation,
                    state: e.target.value,
                  })
                }
                placeholder="State"
              />
            </div>

            <div className="w-full flex justify-center items-center mt-6">
              <motion.button
                type="submit"
                whileHover={{ y: 5 }}
                className="text-white bg-[#d8232a] p-2 rounded-full w-full max-w-xs"
              >
                Search
              </motion.button>
            </div>
          </form>

          {error && <ErrorMessage error={error} />}
        </div>

        {pincode || state || name || address || division || location ? (
          <div className="w-full lg:w-1/2 lg:ml-8 mt-6 lg:mt-0">
            <PostalCodeDetails
              pincode={pincode}
              state={state}
              district={district}
              name={name}
              address={address}
              division={division}
            />
            {location && (
              <MapComponent
                location={location}
                name={name}
                district={district}
                state={state}
                pincode={pincode}
              />
            )}
          </div>
        ) : (
          <div className="flex flex-col gap-6 mt-11 lg:w-1/2 lg:mt-0 lg:ml-11">
            <h2 className="border border-yellow-300 bg-yellow-50 text-yellow-800 w-fit px-3 py-1 rounded-lg font-medium font-display">
              About Pincode
            </h2>
            <div className="flex flex-col gap-6 lg:w-98 font-light font-display justify-center items-center lg:items-start">
              <h3 className="tracking-wider leading-8 lg:leading-6 text-white text-lg font-semibold">
                A PIN Code in India is a specific code assigned to one or
                several post office(s) in one geography by the Indian Postal
                Services to facilitate easy and accurate delivery of posts and
                parcels. The system was introduced on 15th August, 1972.
              </h3>
              <h3 className="tracking-wider leading-8 lg:leading-6 text-white text-lg font-semibold">
                The term Pincode stands for Postal Index Number Code. A Pincode
                typically consists of 6 digits and each of them indicates
                specific information about the region.
              </h3>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocatorF;
